import { Link } from "react-router-dom";
import { Category } from "@/data/categories";

export default function CategoryPreview({ categories }: { categories: Category[] }) {
  return (
    <div className="container mx-auto py-12">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold mb-3">Popular Categories</h2>
        <p className="text-gray-500 max-w-2xl mx-auto">
          Browse AI tools by category to find the perfect solution for your needs
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {categories.map((category) => (
          <div key={category.id} className="card group">
            <div className="p-6">
              <div className="flex items-center mb-5">
                <div className="bg-[var(--primary)]/10 p-3 rounded-lg mr-4 group-hover:bg-[var(--primary)]/20 transition-colors">
                  <i className={`${category.icon} text-2xl text-[var(--primary)]`}></i>
                </div>
                <h3 className="text-xl font-semibold">{category.name}</h3>
              </div>
              <div className="space-y-3">
                {category.tools.map((tool) => (
                  <Link 
                    key={tool.id} 
                    to={`/tool/${tool.id}`}
                    className="block hover:bg-gray-50 p-3 rounded-lg transition-colors flex items-center"
                  >
                    <i className="fa-solid fa-caret-right text-xs text-gray-400 mr-3"></i>
                    {tool.name}
                  </Link>
                ))}
              </div>
              <Link
                to={`/category/${category.id}`}
                className="mt-6 inline-flex items-center text-[var(--primary)] hover:text-[var(--primary-dark)] font-medium transition-colors"
              >
                View all {category.name} tools
                <i className="fa-solid fa-arrow-right ml-2"></i>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}